/**
 * @generated SignedSource<<1817ef7470a78b23eae96082a36f0b5f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type FocusMembershipQuery$variables = {
  classId: string;
  validCurrentRoadmapsOnly?: boolean | null | undefined;
};
export type FocusMembershipQuery$data = {
  readonly class: {
    readonly id: string;
    readonly users: ReadonlyArray<{
      readonly id: string;
      readonly isActive: boolean;
      readonly roles: ReadonlyArray<{
        readonly name: string | null | undefined;
      } | null | undefined> | null | undefined;
      readonly studentTargetGroups: ReadonlyArray<{
        readonly isCurrent: boolean;
        readonly targetGroup: {
          readonly id: string;
          readonly name: string | null | undefined;
        } | null | undefined;
      } | null | undefined> | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
};
export type FocusMembershipQuery = {
  response: FocusMembershipQuery$data;
  variables: FocusMembershipQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "classId"
  },
  {
    "defaultValue": true,
    "kind": "LocalArgument",
    "name": "validCurrentRoadmapsOnly"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "classId",
    "variableName": "classId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isActive",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v5 = [
  {
    "kind": "Variable",
    "name": "validCurrentRoadmapsOnly",
    "variableName": "validCurrentRoadmapsOnly"
  }
],
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isCurrent",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "concreteType": "TargetGroupNode",
  "kind": "LinkedField",
  "name": "targetGroup",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    (v4/*: any*/)
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "FocusMembershipQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ClassNode",
        "kind": "LinkedField",
        "name": "class",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserNode",
            "kind": "LinkedField",
            "name": "users",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "RoleNode",
                "kind": "LinkedField",
                "name": "roles",
                "plural": true,
                "selections": [
                  (v4/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v5/*: any*/),
                "concreteType": "StudentTargetGroupNode",
                "kind": "LinkedField",
                "name": "studentTargetGroups",
                "plural": true,
                "selections": [
                  (v6/*: any*/),
                  (v7/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "FocusMembershipQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ClassNode",
        "kind": "LinkedField",
        "name": "class",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserNode",
            "kind": "LinkedField",
            "name": "users",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "RoleNode",
                "kind": "LinkedField",
                "name": "roles",
                "plural": true,
                "selections": [
                  (v4/*: any*/),
                  (v2/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v5/*: any*/),
                "concreteType": "StudentTargetGroupNode",
                "kind": "LinkedField",
                "name": "studentTargetGroups",
                "plural": true,
                "selections": [
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v2/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "0bf55393d5a196477b0fe260ab828408",
    "id": null,
    "metadata": {},
    "name": "FocusMembershipQuery",
    "operationKind": "query",
    "text": "query FocusMembershipQuery(\n  $classId: ID!\n  $validCurrentRoadmapsOnly: Boolean = true\n) {\n  class(classId: $classId) {\n    id\n    users {\n      id\n      isActive\n      roles {\n        name\n        id\n      }\n      studentTargetGroups(validCurrentRoadmapsOnly: $validCurrentRoadmapsOnly) {\n        isCurrent\n        targetGroup {\n          id\n          name\n        }\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "d6a1bf7df7828755b5b97ede6db1e2d8";

export default node;
